/* eslint-disable consistent-return */
import deleteItems from '@services/cart/deleteItems';
import { errorAction, successfulAction } from '@shared/actions';
import { DELETE_LINES } from '@core/reducers/cart/actionTypes';
import getCartId from '@core/reducers/cart/selectors/getCartId';
import getCartFeaturedProduct from '@core/reducers/cart/selectors/getCartFeaturedProduct';
import updateCart from '@services/cart/updateCart';
import trackCartUpdated from '@conversion/tracking/actions/trackCartUpdated';
import getCartItems from '../selectors/getCartItems';

const type = DELETE_LINES;
const msg =
  'Ocurrió un error al eliminar los productos. Por favor intente nuevamente.';

const deleteCartItems = ({ lines, origin, errorMessage = msg }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    dispatch({ type });

    const state = getState();
    const cartId = getCartId(state);
    const prevCartItems = getCartItems(state);

    const { success: successDelete } = await deleteItems({
      axios,
      lines,
      cartId,
    });

    const { success: successFetch, data, error } = await updateCart({
      axios,
      cartId,
      payload: {},
    });

    if (successDelete && successFetch) {
      dispatch(trackCartUpdated(data.items, prevCartItems, origin));
      dispatch(
        successfulAction({
          type,
          payload: {
            cart: data,
            featuredProduct: getCartFeaturedProduct(state),
          },
        }),
      );
      return data?.items;
    }
    dispatch(errorAction({ type, error, errorMessage }));
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage }));
  }
};

export default deleteCartItems;
